import ky from '../ky';

export const getLanguages = () => ky.get(`Language`);

export const getAllLanguages = () => ky.get('Language/all');